import httpClient from "@/config/httpClient";

export const swrFetcher = async ([
	url,
	options = {
		method: "get",
	},
]) => {
	const ret = await httpClient[options.method](url);

	if (ret.isError) throw new Error(ret.response.error);
	return ret.response;
};
